import { createSelector } from '@ngrx/store';
import { CashBackMembership, LoyaltyProgram } from '@rd/types';
import {
  getMembershipLoading,
  getMembershipMemberships,
  getMembershipsIsLoaded,
} from './membership.selectors';
import {
  getFetchRedeemCashLoyaltyProgramLoading,
  getRedeemCashLoyaltyPrograms,
} from './redeem-cash-loyalty-program.selectors';

// Iterate through all memberships and see which loyaltyProgramId matches the redeem cash loyalty program ID & preferred.
export const getRedeemCashMembership = createSelector(
  getMembershipMemberships,
  getRedeemCashLoyaltyPrograms,
  (memberships, redeemCashLoyaltyPrograms): CashBackMembership | null => {
    if (!redeemCashLoyaltyPrograms || redeemCashLoyaltyPrograms.length === 0) {
      return null;
    }

    const foundPreferredMembership = Object.values(memberships).find(
      (membership) => {
        return membership.preferred;
      },
    );

    if (!foundPreferredMembership) {
      return null;
    }

    const foundRedeemCashLoyaltyProgram = redeemCashLoyaltyPrograms.find(
      (loyaltyProgram) =>
        loyaltyProgram.id === foundPreferredMembership.loyaltyProgramId,
    );

    if (!!foundPreferredMembership && !!foundRedeemCashLoyaltyProgram) {
      return foundPreferredMembership as CashBackMembership;
    } else {
      return null;
    }
  },
);

export const getPreferredRedeemCashLoyaltyProgram = createSelector(
  getMembershipMemberships,
  getRedeemCashLoyaltyPrograms,
  (memberships, redeemCashLoyaltyPrograms): LoyaltyProgram | null => {
    if (!redeemCashLoyaltyPrograms || redeemCashLoyaltyPrograms.length === 0) {
      return null;
    }

    const foundPreferredMembership = Object.values(memberships).find(
      (membership) => {
        return membership.preferred;
      },
    );

    if (!foundPreferredMembership) {
      return redeemCashLoyaltyPrograms[0];
    }

    const foundRedeemCashLoyaltyProgram = redeemCashLoyaltyPrograms.find(
      (loyaltyProgram) =>
        loyaltyProgram.id === foundPreferredMembership.loyaltyProgramId,
    );

    if (!!foundPreferredMembership && !!foundRedeemCashLoyaltyProgram) {
      return foundRedeemCashLoyaltyProgram as LoyaltyProgram;
    } else {
      return null;
    }
  },
);

// Iterate through all memberships and see which loyaltyProgramId matches the redeem cash loyalty program ID, and return its account number.
// For all other cases, return null.
export const getRedeemCashLinkedAccountNumber = createSelector(
  getRedeemCashMembership,
  (redeemCashMembership): string | null | undefined => {
    if (!!redeemCashMembership) {
      return redeemCashMembership.number;
    } else {
      return null;
    }
  },
);

export const getRedeemCashLoyaltyProgramOrMembershipsAreLoading =
  createSelector(
    getFetchRedeemCashLoyaltyProgramLoading,
    getMembershipLoading,
    getMembershipsIsLoaded,
    (
      redeemCashLoyaltyProgramIsLoading,
      membershipsAreLoading,
      membershipsHaveLoaded,
    ) => {
      return (
        redeemCashLoyaltyProgramIsLoading ||
        (!membershipsHaveLoaded && membershipsAreLoading)
      );
    },
  );
